<template>
  <div class="card p-3 mb-3 shadow">
    <div class="pt-2 mb-3">
      <button class="btn btn-primary" @click="openPrescriptionId('new')">
        Добавить новую терапию
      </button>

      <button class="btn btn-light" @click="openFavorites">
        Добавить терапию из избранных
      </button>

      <div class="float-right">
        <select class="form-control" id="filter" v-model="filter">
          <option value="active" selected>Только активные назначения</option>
          <option value="archive" selected>Только архивные назначения</option>
          <option value="all" selected>Все назначения</option>
        </select>
      </div>
    </div>

    <div v-for="(catalogParent, catalogParentKey) in catalogs"
         :key="catalogParentKey"
         class="mb-2">
      <div class="font-weight-bold">{{catalogParent.name}}</div>

      <div class="collapse show" :id="'parent' + catalogParent.id">
        <div class="mb-1 ml-3 list-group"
             v-for="(prescription, prescriptionKey) in catalogParent.prescriptions"
             :key="prescriptionKey">
          <ClientDrugItem
              :prescription="prescription"
              v-on:select-prescription-id="openPrescriptionId"/>
        </div>

        <div class="ml-3" :id="'accordion' + catalogParent.id">
          <div v-for="(catalogChild, catalogChildKey) in catalogParent.inner"
               :key="catalogChildKey"
               class="mb-2 box box-solid">
            <div data-toggle="collapse"
                 :data-parent="'#accordion' + catalogParent.id"
                 :href="'#child' + catalogChild.id"
                 aria-expanded="false"
                 class="collapsed font-weight-bold mb-2">
              {{catalogChild.name}}
            </div>

            <div
                :id="'child' + catalogChild.id"
                class="panel-collapse collapse show"
                aria-expanded="false">
              <div class="ml-3 list-group"
                   v-for="(prescription, prescriptionKey) in catalogChild.prescriptions"
                   :key="prescriptionKey">
                <ClientDrugItem
                    :prescription="prescription"
                    v-on:select-prescription-id="openPrescriptionId"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ClientDrugItem from './Item';

  export default {
    name: 'ClientDrugList',

    props: ['drugPrescriptions'],

    components: {ClientDrugItem},

    data() {
      return {
        filter: 'active',
      };
    },

    computed: {
      catalogs() {
        const catalogs = this.$store.state.catalogs.map(
          ({id, name, parent, sort}) => ({id, name, parent, sort, prescriptions: [], inner: []})
        );

        catalogs.push({id: null, name: 'Без категории', parent: null, prescriptions: [], inner: []});

        this.drugPrescriptions.forEach(prescription => {
          if (prescription.archived && this.filter === 'active') {
            return;
          }

          if (!prescription.archived && this.filter === 'archive') {
            return;
          }

          const prescriptionCatalogId = prescription.drug.ingredient.catalog ? prescription.drug.ingredient.catalog.id : null;

          catalogs.forEach(catalog => {
            if (catalog.id === prescriptionCatalogId) {
              catalog.prescriptions.push(prescription);
            }
          });
        });

        catalogs.forEach(child => {
          catalogs.forEach(parent => {
            if (child.parent === null || child.parent !== parent.id || child.prescriptions.length === 0) {
              return;
            }

            parent.inner.push(child);
          });
        });

        const filteredCatalogs = catalogs.filter(catalog => {
          return (catalog.prescriptions.length > 0 || catalog.inner.length > 0) && catalog.parent === null;
        });

        filteredCatalogs.sort((a, b) => a.sort - b.sort);

        filteredCatalogs.forEach(catalog => {
          catalog.inner.sort((a, b) => a.sort - b.sort);
        });

        return filteredCatalogs;
      }
    },

    methods: {
      openPrescriptionId(id) {
        this.$emit('open-prescription-id', id);
      },

      openFavorites() {
        this.$store.dispatch('CHANGE_VIEW', 'favorites');
      },
    },
  };
</script>
